const messageResponse = (xmlElement) => {
    const rootMessageRes = xmlElement.getElementsByTagName("MessageResponse")[0];
    const IdMessage = rootMessageRes.attributes?.Id?.value ?? ''

    return IdMessage;
}

export default messageResponse;